<div class="claims-wrapper">
  <div class="claims-header" (click)="redirectToHomePage()">
    <img src="../../../../assets/images/arrow-right.png" alt="">
    Claims
  </div>

  <div class="claims-body">
    <mat-tab-group mat-stretch-tabs class="example-stretched-tabs mat-elevation-z4" [selectedIndex]="0">
      <mat-tab label="Raise a Claim" aria-selected="true">
        <div class="raise-claim-wrapper">
          <div class="raise-claim-left">
            <img src="../../../../assets/images/raise-claim-1.png" alt="">
          </div>
          <div class="raise-claim-right">

            <div class="raise-claim-right-card">
              <div class="raise-claim-right-card-logo">
                <img src="../../../../assets/images/shield-icon.png" alt="">
              </div>
              <div class="raise-claim-right-card-content">
                <div class="raise-claim-right-card-title">Your Rides are Insured</div>
                <div class="raise-claim-right-card-description">Stay protected during your rides, on and off duty</div>

              </div>
            </div>
            <div class="raise-claim-right-card">
              <div class="raise-claim-right-card-logo">
                <img src="../../../../assets/images/family-icon.png" alt="">
              </div>
              <div class="raise-claim-right-card-content">
                <div class="raise-claim-right-card-title">OPD coverage in case of Accident</div>
                <div class="raise-claim-right-card-description">Covers non-hospitalization expenses including
                  consultation, X-ray, diagnosis, and medication in accidental cases
                </div>

              </div>
            </div>
            <div class="raise-claim-right-card">
              <div class="raise-claim-right-card-logo">
                <img src="../../../../assets/images/hospital-icon.png" alt="">
              </div>
              <div class="raise-claim-right-card-content">

                <div class="raise-claim-right-card-title">10,000+ Network Hospitals</div>
                <div class="raise-claim-right-card-description">Enjoy cashless treatment at our extensive hospital
                  network.</div>
              </div>
            </div>
            <div class="raise-claim-right-card">
              <div class="raise-claim-right-card-logo">
                <img src="../../../../assets/images/doctor-icon.png" alt="">
              </div>
              <div class="raise-claim-right-card-content">
                <div class="raise-claim-right-card-title">Free Doctor Help on Call</div>
                <div class="raise-claim-right-card-description">Talk to a doctor anytime at no extra cost by using the
                  Visit app. You can download the app from the Play Store.</div>

              </div>
            </div>

            <div class="start-claim" (click)="redirectToStartClaim()">
              Start Claim
            </div>
          </div>


        </div>

      </mat-tab>
      <mat-tab label="Track Claim">

        <div class="track-claim-wrapper">
          <!-- app.component.html -->

          <!-- <mat-stepper orientation="vertical" [linear]="false" #stepper>
  <mat-step 
    *ngFor="let statusItem of statusHistory" 
    [label]="statusItem.status" 
    [completed]="true" 
    [selected]="statusItem === statusHistory[statusHistory.length - 1]"
  >
    <p>{{ statusItem.details }}</p>
    <small>{{ statusItem.date }}</small>
  </mat-step>
</mat-stepper> -->

          <div class="track-claim-header">
            Track Claims
          </div>
          <div class="track-claim-filters">
            <div (click)="showAllClaims()" [ngClass]="{ active: activeFilter === 'all' }">All</div>
            <div (click)="showActiveClaims()" [ngClass]="{ active: activeFilter === 'active' }">Open</div>
            <div (click)="showClosedClaims()" [ngClass]="{ active: activeFilter === 'closed' }">Closed</div>
            <div *ngIf="hasRepudiatedClaim" (click)="showRepudiatedClaims()"
              [ngClass]="{ active: activeFilter === 'rejected' }">Rejected</div>
          </div>



          <!-- SKELETON: Claims Grid -->
          <div class="claims-grid" *ngIf="!isFamilyClaimsDetailsLoaded">
            <div class="claims-cell" *ngFor="let _ of skeletonItems">
              <div class="claims-cell-details">
                <!-- Top -->
                <div class="claims-cell-details-top">
                  <div class="left">
                    <div class="skel text w-40"></div>
                    <div class="skel text w-60 mt-6"></div>
                  </div>
                  <div class="right">
                    <!-- <div class="skel chip w-60"></div> -->
                  </div>
                </div>

                <!-- Mid (3 columns of key/value) -->
                <div class="claims-cell-details-mid">
                  <div>
                    <div class="skel key w-40"></div>
                    <div class="skel text w-70 mt-6"></div>
                  </div>
                  <div>
                    <div class="skel key w-45"></div>
                    <div class="skel text w-50 mt-6"></div>
                  </div>
                  <div>
                    <div class="skel key w-50"></div>
                    <div class="skel text w-40 mt-6"></div>
                  </div>
                </div>

                <!-- Bottom -->
                <div class="claims-cell-details-bottom">
                  <div class="skel badge w-30"></div>
                  <div class="claims-progress-bar">

                  </div>
                </div>
              </div>

              <!-- Actions -->
              <div class="claims-cell-actions">
                <div class="skel btn w-40"></div>
                <div class="skel btn w-55"></div>
              </div>
            </div>
          </div>

          <!-- REAL GRID: show when data is ready -->
          <div class="claims-grid" *ngIf="isFamilyClaimsDetailsLoaded">
            <!-- your existing template -->
            <div class="claims-cell" *ngFor="let fcd of filteredClaims">
              <div class="claims-cell-details">
                <div class="claims-cell-details-top">
                  <div class="left">
                    <div class="claim-id">Claim ID : {{ fcd.claimNo }}</div>
                    <!-- <div class="type">Hospitalization Type - <span>{{fcd.reimbursementType}}</span></div> -->
                  </div>
                  <div class="right" *ngIf="fcd.isActiveClaim">Active</div>
                  <div class="right red" *ngIf="!fcd.isActiveClaim">{{fcd.claimStatus === 'Repudiated' ? "Rejected" :
                    "Closed"}}</div>
                </div>

                <div class="claims-cell-details-mid">
                  <div>
                    <div class="key">Patient Name</div>
                    <div class="value">{{ fcd.insuredName }}</div>
                  </div>
                  <div>
                    <div class="key">Admission Date</div>
                    <div class="value">{{ fcd.admissionDate | date }}</div>
                  </div>
                  <div>
                    <div class="key">Claim Amount</div>
                    <div class="value">{{ fcd.claimAmount | currency:'INR':'symbol':'1.0-2':'en-IN' }}</div>
                  </div>
                </div>

                <div class="claims-cell-details-bottom">
                  <div class="status">{{ fcd.claimStatus }}</div>
                  <div class="claims-progress-bar" *ngIf="fcd.isClaimJourneyLoaded">
                    <!-- {{fcd | json}} -->
                    <div *ngFor="let i of [1,2,3,4,5,6,7,8]" [ngClass]="fcd.claimStatus == 'Closed'  || fcd.claimStatus == 'Claim settled' || (fcd.claimStatus =='Repudiated' && i < 8) || (fcd.claimStatus !=='Repudiated' && fcd.ls > i)
                                          ? 'success'
                                          :fcd.claimStatus =='Repudiated' && i == 8 
                                          ? 'failed'
                                              :
                                            !fcd.claimJourney['s' + i]
                                              ? 'pending'
                                              : fcd.claimJourney['s' + i].isCurrentState
                                                ? 'current'
                                                : 'pending'
                                          ">
                    </div>
                  </div>
                </div>
              </div>

              <div class="claims-cell-actions">
                <div class="track-claim-button" (click)="redirectToClaimDetails(fcd.claimNo)">{{fcd.claimStatus==="Claim
                  settled" ? 'View Breakdown' : 'View Details'}}</div>
                <div class="upload-document-button" *ngIf="fcd.isActiveClaim && !((fcd.claimJourney.s7 !== null && fcd.claimJourney.s7.isStageCompleted) ||
                  (fcd.claimJourney.s8 !== null && fcd.claimJourney.s8.isStageCompleted) ||
                  (fcd.claimJourney.s9 !== null && fcd.claimJourney.s9.isStageCompleted) ||
                  (fcd.claimJourney.s10 !== null && fcd.claimJourney.s10.isStageCompleted))"
                  (click)="redirectToUploadDocuments(fcd.claimNo)">Upload Document
                </div>
                <div class="upload-document-button" *ngIf="(fcd.claimJourney.s7 !== null && fcd.claimJourney.s7.isStageCompleted) ||
                  (fcd.claimJourney.s8 !== null && fcd.claimJourney.s8.isStageCompleted) ||
                  (fcd.claimJourney.s9 !== null && fcd.claimJourney.s9.isStageCompleted) ||
                  (fcd.claimJourney.s10 !== null && fcd.claimJourney.s10.isStageCompleted)" 
                  (click)="downloadFile(fcd)">
                  
                      {{fcd.claimStatus==="Repudiated" ? 'View Repudiation Letter' : 'View Settlement Letter'}}
                </div>


              </div>
            </div>
          </div>

        </div>
      </mat-tab>
    </mat-tab-group>
  </div>
</div>